const LOG_PREFIX = '[Ticket Details]';

const userInitalState = {
  email: '',
  firstName: '',
  lastName: '',
  fullName: '',
};

const constants = {
  LOG_PREFIX,
  userInitalState,
};

export default constants;
